import { AxiosRequestConfig } from 'axios';

import { CasinoNewsGamesWidgetResponse } from '../Responses/CasinoNewsGamesWidgetResponse';

import GetPaginatedResponse from 'Api/CRM/Responses/PaginatedResponse';
import AbstractCasinoCRMApi from 'casino/Api/AbstractCasinoCRMApi';
import { CasinoGameDeviceType } from 'casino/Api/Models/CasinoGame';
import { API_CASINO_NEWS_WIDGET_GAMES } from 'crm/casino/pages/Helpers/CrmApiUrls';

class NewsGamesWidget extends AbstractCasinoCRMApi {
    public async getWithGames(
        page: number,
        deviceType: CasinoGameDeviceType,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoNewsGamesWidgetResponse>> {
        return (
            await this.get(API_CASINO_NEWS_WIDGET_GAMES, {
                params: { ...config.params, page, device_type: deviceType },
            })
        ).data;
    }
}

export default new NewsGamesWidget();
